import { Box, Button, Image } from '@wix/design-system'
import { StatusCompleteFilled } from '@wix/wix-ui-icons-common/lazy'
import React, { FC } from 'react'

import { TemplateItem } from '../StoresFunnelChooseTemplate.data'
import { storesFunnelChooseTemplateDataHooks as DataHooks } from '../StoresFunnelChooseTemplate.dataHooks'
import s from '../StoresFunnelChooseTemplate.scss'

type TemplateCarouselItemProps = {
  template: TemplateItem
  isSelected: boolean
  onSelect: () => void
  onPreview: () => void
  previewButtonText: string
}

export const TemplateCarouselItem: FC<TemplateCarouselItemProps> = ({
  template,
  isSelected,
  onSelect,
  onPreview,
  previewButtonText,
}) => {
  return (
    <div
      className={s.templateCarouselItem}
      style={{ border: isSelected ? '2px solid #116dff' : '2px solid transparent' }}
      onClick={onSelect}
      data-hook={DataHooks.templateItem({ key: template.templateId })}
    >
      {isSelected && (
        <Box className={s.selectedIndicator}>
          <StatusCompleteFilled color="#116DFF" />
        </Box>
      )}
      <Image
        fit="cover"
        height="100%"
        src={template.imageUrl}
        alt={template.title}
        data-hook={DataHooks.templateImage({ key: template.templateId })}
      />
      <Box className={s.previewButtonContainer}>
        <Button
          priority="secondary"
          fullWidth
          onClick={e => {
            e.stopPropagation()
            onPreview()
          }}
          data-hook={DataHooks.previewButton({ key: template.templateId })}
        >
          {previewButtonText}
        </Button>
      </Box>
    </div>
  )
}
